import React from 'react';
import { Profile } from 'components';

export const ProfilePage = () => {
    return <Profile />;
};
